module.exports = __webpack_public_path__ + "static/media/deleteCrossDarkMode.8847c51a.svg";